export default {
  id: null,
  slug: null,
  title: null,
  datePublished: null,
  dateModified: null,
  category: null,
  content: null,
  image: {
    url: null,
    altText: null,
    caption: null,
    width: null,
    height: null,
    useFilter: null
  }
}
